// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--wnadR","balance_wrapper":"dd31006766--balance_wrapper--OuiR0","balance":"dd31006766--balance--zkfqh"};